import "es6-shim";
import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import scrollToElement from 'scroll-to-element';

const formAutocomplete = function autoComplete() {
    const form = document.querySelector('.wrapper-form form');
    const name = form.querySelectorAll('input[name="paywall[name]"]');
    const email = form.querySelectorAll('input[name="paywall[email]"]');
    function getQueryVariable(variable) {
        const query = decodeURIComponent(window.location.search.substring(1));
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i += 1) {
            const pair = vars[i].split('=');
            if (pair[0] === variable) { return pair[1]; }
        }
        return (false);
    }
    const valName = getQueryVariable('name');
    const valEmail = getQueryVariable('email');
    if (valEmail) {
        name[0].classList.add('not-empty');
        name[0].value = valName;
    }
    if (valEmail) {
        email[0].classList.add('not-empty');
        email[0].value = valEmail;
    }
};

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    const accessForm = document.querySelector('.wrapper-form form');

    if (accessForm) {
        formAutocomplete();
        formValidation(accessForm, {
            plugins: {
                trigger: new Trigger(),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                recaptcha: new Recaptcha({
                    element: 'paywall_captcha_container',
                    siteKey: '6LdXyp0UAAAAABMqylYVIyo4xxeV-tDkoXh8rNFg',
                    size: 'invisible',
                    message: JSON.parse(
                        document.querySelector('#json_translations').innerHTML,
                    ).reCaptchaErrorMessage,
                }),
            },
        });
        const formControl = accessForm.querySelectorAll('input.form-control');
        [].forEach.call(formControl, (input) => {
            if (input.value !== '') {
                input.classList.add('not-empty');
                input.classList.remove('empty');
            }
            input.addEventListener('blur', function classOnBlur() {
                const tmpval = this.value;
                if (tmpval === '') {
                    this.classList.add('empty');
                    this.classList.remove('not-empty');
                } else {
                    this.classList.add('not-empty');
                    this.classList.remove('empty');
                }
            });
        });
    }
    [].forEach.call(document.querySelectorAll('a[data-anchor]'), (anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            if (typeof (anchor) !== 'undefined' && anchor != null) {
                e.preventDefault();
                const target = anchor.getAttribute('href');
                scrollToElement(document.querySelector(target), {
                    offset: -50,
                    duration: 500,
                });
            }
        });
    });
}));
